import React, { useEffect, useRef, useState } from "react";

import { useDebounce } from "usehooks-ts";

import { TextInput } from "./text-input";

interface Props {
  value: string;
  isDisabled?: boolean;
  placeholder?: string;
  label?: string;
  delay?: number;
  className?: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

export const DebouncedTextInput = ({
  value,
  isDisabled,
  placeholder,
  label,
  delay,
  className,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
}: Props) => {
  const isInitialRef = useRef(true);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const debouncedValue = useDebounce(localValue, delay || 500);

  useEffect(() => {
    if (!isInitialRef.current) {
      onChange(debouncedValue);
    }

    isInitialRef.current = false;
  }, [debouncedValue]);

  return (
    <TextInput
      inputClassName={className}
      placeholder={placeholder}
      isDisabled={isDisabled}
      label={label}
      onFocus={onFocus}
      onBlur={onBlur}
      value={localValue}
      onKeyDown={onKeyDown}
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
    />
  );
};
